var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCasino(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.499 10.3285L7.02274 14.5L10.499 18.6715L13.9753 14.5L10.499 10.3285ZM10.499 16.3285L8.9753 14.5L10.499 12.6715L12.0227 14.5L10.499 16.3285Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.56562 1.31686C9.74767 1.23437 9.95511 1.22795 10.1419 1.29904L22.2668 5.91317C22.6519 6.05972 22.8466 6.48953 22.7029 6.87572L17.749 20.1867V22C17.749 22.4142 17.4132 22.75 16.999 22.75L3.99902 22.75C3.58481 22.75 3.24902 22.4142 3.24902 22L3.24902 7C3.24902 6.58579 3.58481 6.25 3.99902 6.25L7.49321 6.25L9.17226 1.73841C9.24197 1.55109 9.38357 1.39935 9.56562 1.31686ZM21.0374 7.05029L17.749 15.8862L17.749 7C17.749 6.58579 17.4132 6.25 16.999 6.25L9.09372 6.25L10.3145 2.96968L21.0374 7.05029ZM4.74902 7.75L4.74902 21.25L16.249 21.25L16.249 7.75L4.74902 7.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCasino);
export default __webpack_public_path__ + "static/media/ic_casino.370d482997865646a5ca8429c879be96.svg";
export { ForwardRef as ReactComponent };